import { render, staticRenderFns } from "./FacebookAdsTab.vue?vue&type=template&id=f62537d4&scoped=true"
import script from "./FacebookAdsTab.vue?vue&type=script&lang=js"
export * from "./FacebookAdsTab.vue?vue&type=script&lang=js"
import style0 from "./asset-split.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./FacebookAdsTab.vue?vue&type=style&index=1&id=f62537d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62537d4",
  null
  
)

export default component.exports